module.exports = __webpack_public_path__ + "static/img/dl_WalletConnect.d71cbee6.png";